import { render, staticRenderFns } from "./orderSort.vue?vue&type=template&id=436b41cc&scoped=true"
import script from "./orderSort.vue?vue&type=script&lang=js"
export * from "./orderSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b41cc",
  null
  
)

export default component.exports